import React, { useState } from "react";
import { category } from "../data/Data";
import { useNavigate } from "react-router-dom";
import "../css/components.css";
import { CATEGORY_BY_SLUG } from "../seo/categories";

export default function Categories() {
  const navigate = useNavigate();
  const [hoveredCategory, setHoveredCategory] = useState(null);

  /**
   * Sends the visitor to the category's own landing page.
   *
   * This used to push `/shop?category=<display name>` — note the display name,
   * not the slug, so "Incense Sticks" never matched the `incense-sticks` value
   * on the products and the grid came back empty every time. Resolving through
   * the slug fixes that as a side effect of moving to the real URLs.
   */
  const handleCategoryClick = (categoryName) => {
    const cat = category.find((c) => c.category_name === categoryName);
    const page = cat && CATEGORY_BY_SLUG[cat.slug];
    navigate(page ? page.path : "/shop");
  };

  const categoryBenefits = {
    "Incense Sticks": {
      icon: "fa-leaf",
      benefit: "Long-lasting fragrance",
      color: "#28a745"
    },
    "Dhoop Sticks": {
      icon: "fa-fire",
      benefit: "Intense aroma therapy",
      color: "#fd7e14"
    },
    "Dhoop Cone": {
      icon: "fa-mountain",
      benefit: "Concentrated essence",
      color: "#6f42c1"
    },
    "Sambrani Cup": {
      icon: "fa-spa",
      benefit: "Traditional purity",
      color: "#dc3545"
    }
  };

  return (
    <>
      <div className="categories-section">
        <div className="container-fluid">
          {/* Section Header */}
          <div className="row">
            <div className="col-12 text-center mb-5">
              <div className="section-header">
                <span className="section-badge">Our Collection</span>
                <h2 className="section-title-professional">
                  Explore Our <span className="highlight-text">Premium Range</span>
                </h2>
                <p className="section-subtitle-professional">
                  Discover authentic fragrances crafted with natural ingredients for every spiritual moment
                </p>
              </div>
            </div>
          </div>

          {/* Categories Grid */}
          <div className="row px-xl-5">
            {category.map((item, index) => {
              const benefit = categoryBenefits[item.category_name] || {
                icon: "fa-star",
                benefit: "Premium quality",
                color: "#667eea"
              };
              
              return (
                <div className="col-lg-3 col-md-6 col-sm-6 mb-4" key={index}>
                  <div 
                    className={`modern-category-card ${hoveredCategory === index ? 'hovered' : ''}`}
                    onMouseEnter={() => setHoveredCategory(index)}
                    onMouseLeave={() => setHoveredCategory(null)}
                    onClick={() => handleCategoryClick(item.category_name)}
                  >
                    {/* Background Pattern */}
                    <div className="category-bg-pattern"></div>
                    
                    {/* Category Image */}
                    <div className="category-image-container">
                      <img
                        src={item.img}
                        alt={`${item.category_name} by NT Sticks`}
                        className={`category-image${
                          item.imgFit === "contain" ? " category-image--contain" : ""
                        }`}
                      />
                      <div className="image-overlay"></div>
                    </div>
                    
                    {/* Category Content */}
                    <div className="category-content">
                      <div className="category-icon" style={{ color: benefit.color }}>
                        <i className={`fas ${benefit.icon}`}></i>
                      </div>
                      
                      <h4 className="category-title">{item.category_name}</h4>
                      
                      <div className="category-stats">
                        <span className="product-count">{item.quantity}</span>
                        <span className="benefit-text">{benefit.benefit}</span>
                      </div>
                      
                      {/* Subcategories Preview */}
                      {item.subCat && item.subCat.length > 0 && (
                        <div className="subcategories-preview">
                          <div className="subcategory-tags">
                            {item.subCat.slice(0, 3).map((subcat, subIndex) => (
                              <span key={subIndex} className="subcategory-tag">
                                {subcat.category_name}
                              </span>
                            ))}
                            {item.subCat.length > 3 && (
                              <span className="more-tag">+{item.subCat.length - 3} more</span>
                            )}
                          </div>
                        </div>
                      )}
                      
                      {/* CTA Button */}
                      <div className="category-cta">
                        <button className="explore-btn">
                          <span style={{ color: "white" }}>Explore Collection</span>
                          <i className="fas fa-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                    
                    {/* Hover Effect */}
                    <div className="category-hover-effect"></div>
                  </div>
                </div>
              );
            })}
          </div>
          
          {/* Bottom CTA */}
          <div className="row mt-5">
            <div className="col-12 text-center">
              <div className="categories-bottom-cta">
                <h5>Can't find what you're looking for?</h5>
                <p>Browse our complete collection or contact us for custom requirements</p>
                <div className="cta-buttons">
                  <button 
                    className="btn-view-all"
                    onClick={() => navigate('/shop')}
                  >
                    <i className="fas fa-th-large"></i>
                    View All Products
                  </button>
                  <button 
                    className="btn-contact"
                    onClick={() => navigate('/contact')}
                  >
                    <i className="fas fa-phone"></i>
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
